// auto-generated by Typewriter template _models.tst from PortCall.Models\Utils\Image.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// ImageData is the class that Image serializes to/from
export interface ImageData {
	
    ProfileUrl : string;
    RawUrl : string | null;
    ThumbUrl : string;
    UploadProfileUrl : string | null;
    UploadThumbUrl : string | null;
	
    CropX1 : number;
    CropX2 : number;
    CropY1 : number;
    CropY2 : number;
    RawHeight : number;
    RawWidth : number;
}

// ImageOptions is the class which may be passed to the Image constructor to define optional initial data values
export interface ImageOptions {
	
    ProfileUrl? : string;
    RawUrl? : string | null;
    ThumbUrl? : string;
    UploadProfileUrl? : string | null;
    UploadThumbUrl? : string | null;
	
    CropX1? : number;
    CropX2? : number;
    CropY1? : number;
    CropY2? : number;
    RawHeight? : number;
    RawWidth? : number;
}

export class Image {
	
    public ProfileUrl : DataSignal<string>;
    public RawUrl : DataSignal<string | null>;
    public ThumbUrl : DataSignal<string>;
    public UploadProfileUrl : DataSignal<string | null>;
    public UploadThumbUrl : DataSignal<string | null>;
	
    public CropX1 : DataSignal<number>;
    public CropX2 : DataSignal<number>;
    public CropY1 : DataSignal<number>;
    public CropY2 : DataSignal<number>;
    public RawHeight : DataSignal<number>;
    public RawWidth : DataSignal<number>;

    constructor();
    constructor(data : ImageOptions);
    constructor(data: ImageOptions | null = null) {
	    
        this.ProfileUrl = jsonableObservable(S.value<string>(data && data.ProfileUrl !== undefined ? data.ProfileUrl : ''));
        this.RawUrl = jsonableObservable(S.value<string | null>(data && data.RawUrl !== undefined ? data.RawUrl : null));
        this.ThumbUrl = jsonableObservable(S.value<string>(data && data.ThumbUrl !== undefined ? data.ThumbUrl : ''));
        this.UploadProfileUrl = jsonableObservable(S.value<string | null>(data && data.UploadProfileUrl !== undefined ? data.UploadProfileUrl : null));
        this.UploadThumbUrl = jsonableObservable(S.value<string | null>(data && data.UploadThumbUrl !== undefined ? data.UploadThumbUrl : null));
	    
        this.CropX1 = jsonableObservable(S.value<number>(data && data.CropX1 !== undefined ? data.CropX1 : 0));
        this.CropX2 = jsonableObservable(S.value<number>(data && data.CropX2 !== undefined ? data.CropX2 : 0));
        this.CropY1 = jsonableObservable(S.value<number>(data && data.CropY1 !== undefined ? data.CropY1 : 0));
        this.CropY2 = jsonableObservable(S.value<number>(data && data.CropY2 !== undefined ? data.CropY2 : 0));
        this.RawHeight = jsonableObservable(S.value<number>(data && data.RawHeight !== undefined ? data.RawHeight : 0));
        this.RawWidth = jsonableObservable(S.value<number>(data && data.RawWidth !== undefined ? data.RawWidth : 0));
    }

    static key(obj : Image) {
        return ;
    }
    
    static dataKey(obj : ImageOptions) {
        return ;
    }

    static update(obj : Image, data : ImageOptions) {
        S.freeze(() => {
	        
            if (data.ProfileUrl !== undefined) obj.ProfileUrl(data.ProfileUrl);
            if (data.RawUrl !== undefined) obj.RawUrl(data.RawUrl);
            if (data.ThumbUrl !== undefined) obj.ThumbUrl(data.ThumbUrl);
            if (data.UploadProfileUrl !== undefined) obj.UploadProfileUrl(data.UploadProfileUrl);
            if (data.UploadThumbUrl !== undefined) obj.UploadThumbUrl(data.UploadThumbUrl);
	        
            if (data.CropX1 !== undefined) obj.CropX1(data.CropX1);
            if (data.CropX2 !== undefined) obj.CropX2(data.CropX2);
            if (data.CropY1 !== undefined) obj.CropY1(data.CropY1);
            if (data.CropY2 !== undefined) obj.CropY2(data.CropY2);
            if (data.RawHeight !== undefined) obj.RawHeight(data.RawHeight);
            if (data.RawWidth !== undefined) obj.RawWidth(data.RawWidth);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Image.ts